// 一、导入模块
import React from "react";
import ReactDOM from "react-dom/client";
import { ConfigProvider } from "antd";
import "./styles/tailwind.css";
import "./styles/reset.scss";
import "./styles/antSelectOutlinedGlobal.scss";
import "./styles/antInputOutlinedGlobal.scss";
import "./styles/antSwitchAndToggleGlobal.scss";
import "./styles/antPopconfirmGlobal.scss";
// 引入Font Awesome图标库
import '@fortawesome/fontawesome-free/css/all.min.css';
import { App } from "./App";
import { TAB_BRAND_ICON, APP_NAME, APP_DESCRIPTION } from "./config/constants";

// 动态设置页面标题和meta描述
const setPageTitle = () => {
  // 设置document.title（浏览器标签页标题）
  document.title = `${APP_NAME} - ${APP_DESCRIPTION}`;
  
  // 更新meta description
  let metaDescription = document.querySelector("meta[name='description']") as HTMLMetaElement;
  if (!metaDescription) {
    metaDescription = document.createElement("meta");
    metaDescription.name = "description";
    document.head.appendChild(metaDescription);
  }
  metaDescription.content = `${APP_NAME} - ${APP_DESCRIPTION}`;
};

// 动态设置favicon和apple-touch-icon
const setFavicon = () => {
  // 设置favicon
  let favicon = document.querySelector("link[rel='icon']") as HTMLLinkElement;
  if (!favicon) {
    favicon = document.createElement("link");
    favicon.rel = "icon";
    favicon.type = "image/png";
    document.head.appendChild(favicon);
  }
  favicon.href = TAB_BRAND_ICON;

  // 设置apple-touch-icon
  let appleTouchIcon = document.querySelector("link[rel='apple-touch-icon']") as HTMLLinkElement;
  if (!appleTouchIcon) {
    appleTouchIcon = document.createElement("link");
    appleTouchIcon.rel = "apple-touch-icon";
    document.head.appendChild(appleTouchIcon);
  }
  appleTouchIcon.href = TAB_BRAND_ICON;
};

// 动态生成manifest.json，完全使用全局变量
const generateManifest = () => {
  // 创建或获取manifest链接
  let manifestLink = document.querySelector("link[rel='manifest']") as HTMLLinkElement;
  if (!manifestLink) {
    manifestLink = document.createElement("link");
    manifestLink.rel = "manifest";
    document.head.appendChild(manifestLink);
  }

  // 使用全局变量生成manifest内容
  const manifest = {
    short_name: APP_NAME,
    name: `${APP_NAME} - ${APP_DESCRIPTION}`,
    icons: [
      {
        src: TAB_BRAND_ICON,
        type: "image/png",
        sizes: "192x192"
      },
      {
        src: TAB_BRAND_ICON,
        type: "image/png",
        sizes: "512x512"
      }
    ],
    start_url: "/",
    display: "standalone",
    theme_color: "#000000",
    background_color: "#ffffff"
  };

  // 创建manifest blob URL
  const manifestBlob = new Blob([JSON.stringify(manifest, null, 2)], {
    type: 'application/json'
  });
  const manifestUrl = URL.createObjectURL(manifestBlob);

  // 设置manifest链接
  manifestLink.href = manifestUrl;
};

// 在应用启动时设置页面标题、图标和manifest
setPageTitle();
setFavicon();
generateManifest();

// 二、创建root跟对象
const root = ReactDOM.createRoot(
    document.getElementById("root")  as HTMLElement
)

// 三、渲染项目
root.render(
  <ConfigProvider
    theme={{
      token: {
        // 统一 Ant Design disabled 颜色，避免不同机器/不同构建下因为样式覆盖不命中而回退到默认值
        colorTextDisabled: "rgba(255, 255, 255, 0.85)",
        colorBgContainerDisabled: "rgba(0, 0, 0, 0.2)"
      }
    }}
  >
    <App />
  </ConfigProvider>
)  //重点调用了App组件